
import {Vue, Component} from 'vue-property-decorator';
import Template from "@/views/system-management/template/index.vue";
import {querySplitDetail, splitFactoryInvoice} from "@/api/invoice/index";
import {queryFactoryInvoicePurchaseOrder} from "@/api/factory-invoices";

@Component({ name: 'DismantleInvoice',
  components: {Template}
})
export default class DismantleInvoice extends Vue {

  private showDialog = false;
  private confirmLoading = false;

  private bookingOrderInvoice: any = {};
  private tableData = [];
  private units = [];
  private purchaseOrderCodes = [];
  private initRowData = {
    id: null,
    qty: null,
    amount: null,
    purchaseOrderCodes: [],
    canModified: true,
    transferInFactoryInvoiceCode: '',
    transferOutFactoryInvoiceCode: '',
  };
  get statistics() {
    return  this.units
        .map(item => {
          const filter = this.tableData.filter(tb => tb.unit === item);
          const qty = filter.reduce((total, item) => total + item.qty, 0);
          const amount = filter.reduce((total, item) => total + item.amount, 0);
          const qtyEqual = (this.bookingOrderInvoice.qtyAndAmountStatistics.filter(i => i.unit === item)[0]?.qty || 0) === qty;
          const amountEqual = (this.bookingOrderInvoice.qtyAndAmountStatistics.filter(i => i.unit === item)[0]?.amount || 0) === amount;
          return {qty: qty, qtyEqual: qtyEqual, amountEqual: amountEqual, amount: amount, unit: item};
        });
  }

  public async openDialog(row) {
    const res = await querySplitDetail(row.id) as any;
    this.purchaseOrderCodes = await queryFactoryInvoicePurchaseOrder(row.id) as any;
    this.units = res.qtyAndAmountStatistics.map(item => item.unit);
    const qtyAndAmountDescribe = res.qtyAndAmountStatistics
        .map(item => item.qty + " " + item.unit + " " + item.amount + "(元)")
        .join(',');
    this.bookingOrderInvoice = {...res, qtyAndAmountDescribe: qtyAndAmountDescribe};
    if (this.bookingOrderInvoice.details && this.bookingOrderInvoice.details.length > 0) {
      this.tableData = this.bookingOrderInvoice.details;
    } else {
      this.tableData = [
        {sn: 1, unit: this.units[0], ...this.initRowData},
        {sn: 2, unit: this.units[0], ...this.initRowData}
      ];
    }
    this.showDialog = true;
  }

  private addItem() {
    const maxSn = Math.max(...this.tableData.map(item => item.sn));
    this.tableData.push({ sn: maxSn + 1, unit: this.units[0], ...this.initRowData })
  }

  private getQtyMax(row) {
    return this.bookingOrderInvoice.qtyAndAmountStatistics.filter(item => item.unit === row.unit)[0]?.qty || 0;
  }

  private getAmountMax(row) {
    return this.bookingOrderInvoice.qtyAndAmountStatistics.filter(item => item.unit === row.unit)[0]?.amount || 0;
  }

  private handleDelete(row) {
    const index = this.tableData.findIndex(item => item.sn === row.sn);
    this.tableData.splice(index, 1);
  }

  private async handleSubmit() {
    this.confirmLoading = true;
    await splitFactoryInvoice(
        this.bookingOrderInvoice.id,
        {allocateDetails: this.tableData}
    ).then(() => {
      this.$message({
        message: this.bookingOrderInvoice.code + '拆资料成功',
        type: 'success'
      });
      this.showDialog = false;
      this.$emit('splitDone');
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
}
